export default "__VITE_ASSET__BqUPLrDP__"